<script lang="ts">
  import OffersIllustration from './assets/offers.webp';
</script>

<div
  class="pointer-events-none mx-auto min-w-[400px] max-w-[600px] xl:absolute xl:-right-40 xl:top-20"
>
  <img role="presentation" src={OffersIllustration} alt="" />
</div>
